/// <amd-module name="Widgets/AnalyticsSprintBurndown/AnalyticsSprintBurndownWidget" />
import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import AnalyticsSprintBurndownViewComponent from "./AnalyticsSprintBurndownWidgetComponents/AnalyticsSprintBurndownViewComponent";

export interface IWidgetSettings {}

export class AnalyticsSprintBurndownWidget extends VssComponent<WidgetProps, {}> {
    public render(): JSX.Element | null {
        return (
            <AnalyticsSprintBurndownViewComponent
                {...this.props}
                suppressAnimations={!this.props.showLoadAnimations}
                onRenderCompletion={this.props.onWidgetLoaded}
            />
        );
    }
}

VssComponent.register("analyticsSprintBurndownWidget", AnalyticsSprintBurndownWidget);
